export const isTokenValid = ({ duration, date }) => {
  const oldDate = new Date(date);
  const now = new Date();
  const diff = (now - oldDate) / 1000;
  if (diff < duration.match(/\d+/)[0]) {
    return true;
  }
  return false;
};
